import _ from "underscore";
import Backbone from "backbone";
import Chaplin from "chaplin";
import RSVP from "rsvp";
import RecordingsPageView from "views/myLibrary/RecordingsPageView";
import PersistentModels from "services/PersistentModels";

const RecordingsPageController = Chaplin.Controller.extend({
  initialize: function (options) {
    _.extend(this, Backbone.Events);
    if (options) {
      if (options.view) {
        this.view = options.view;
      }
      if (options.model) {
        this.model = options.model;
      }
    }
  },

  getModel: function () {
    return this.model;
  },

  getView: function () {
    return this.view;
  },

  showHomePopup: function () {
    PersistentModels.getInstance().getRouter().showHomePage();
  },

  showRecorder: function () {
    PersistentModels.getInstance().getRouter().showCreateACapsulePageWithoutContext(null);
  },

  buildModelAndRenderView: function () {
    return new RSVP.Promise(
      function (resolve, reject) {
        try {
          this.view = new RecordingsPageView({});

          this.listenTo(this.view, "showHomePopup", this.showHomePopup);
          this.listenTo(this.view, "showRecorder", this.showRecorder);

          this.view.render();
          resolve();
        } catch (error) {
          reject(error);
        }
      }.bind(this)
    );
  },
});

export default RecordingsPageController;
